import { render, staticRenderFns } from "./TradeWidgetV2.vue?vue&type=template&id=4cc9ace2&scoped=true&"
import script from "./TradeWidgetV2.vue?vue&type=script&lang=js&"
export * from "./TradeWidgetV2.vue?vue&type=script&lang=js&"
import style0 from "./TradeWidgetV2.vue?vue&type=style&index=0&id=4cc9ace2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc9ace2",
  null
  
)

export default component.exports